export const findCategories = (data) => {
  return data.filter(obj => obj.categoryType && obj.categoryType === 'category');
};

export const findSubcategories = (data, id) => {
  return data.filter(
    obj => obj.templateParentCategoryId && (obj.templateParentCategoryId === Number(id) || obj.templateParentCategoryId === id.toString())
  );
};

export const prepareSingleModuleResponseData = (data) => {
  return {
    ...data.modules[0],
    module: data.name,
    suggestions: data.suggestions,
    moduleId: data.id,
  };
};
